import { memo } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFloppyDisk } from '@fortawesome/free-solid-svg-icons/faFloppyDisk'
import { FormattedMessage } from 'react-intl'

export const ConfigVersionOverwriteMsg = memo(
    function ConfigVersionOverwriteMsg() {
        return (
            <span
                className="d-flex align-items-start gap-2 mb-3 p-2"
                style={{
                    fontSize: '0.9rem',
                    backgroundColor: '#FDF1DF',
                    borderRadius: '2px',
                    padding: '5px',
                }}
            >
                <FontAwesomeIcon
                    className="mt-1"
                    color={'#DBB47A'}
                    icon={faFloppyDisk}
                />
                <FormattedMessage id="configuration.configVersionOverwriteMsg" />
            </span>
        )
    }
)
